import Runner from '@protonapp/proton-runner-rn0772'
import legacyRunner from '@protonapp/proton-runner'
import { withFeatureFlags } from 'flags'

export function getRunnerByReactNativeVersion(useNewReactNative) {
  if (useNewReactNative) {
    console.debug('Use runner with new react native version')
    return withFeatureFlags(Runner)
  } else {
    console.debug('Use runner with legacy react native version')
    return withFeatureFlags(legacyRunner)
  }
}
